import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import BookTitle from "~/components/BookTitle";
import AnnotationeerControls from "~/components/AnnotationeerControls";
import PageControls from "~/components/PageControls";
import PlayerControls from "~/components/PlayerControls";

import useMediaQuery from "@mui/material/useMediaQuery";

const AnnotationsMenuBar = styled("div")`
  overflow-x: auto;
  white-space: nowrap;
  background-color: #e0e1e1;
  flex: 0 0 auto;
  position: relative;
`;

const AnnotationsMenuContent = styled("div")`
  display: flex;
  padding: 0;
  justify-content: space-between;
  @media (min-width: 1055px) {
    padding-left: 1em;
  }
`;

const TitleWrapper = styled("div")`
  padding-right: ${props => (props.visible ? 1 : 0)}em;
  display: ${({ visible }) => (visible ? "" : "none")};
`;

const PlayerWrapper = styled("div")`
  width: 100%;
  /* display: flex;
  justify-content: flex-start;
  @media (min-width: 1055px) {
    justify-content: flex-end;
  } */
`;

const CenteredBox = styled("div")`
  @media (min-width: 1055px) {
    position: absolute;
    text-align: center;
    left: calc(50% + ${props => (props.hasPaddingLeft ? 150 : 0)}px - ${props => (props.hasPaddingRight ? 150 : 0)}px);
  }
`;

const PlayerBox = styled("div")`
  display: flex;
  align-content: center;
  justify-content: center;
`;
const PlayerButtons = styled(PlayerControls)`
  /* @media (min-width: 1055px) {
    position: absolute;
    transform: translateX(-50%);
  } */
`;

const getToolbarStyle = () => ({
  paddingLeft: 0,
  paddingRight: 0
});

function AnnotationsMenu({
  sidebarLeftOpen,
  sidebarRightOpen,
  isGreaterThanMedium,
  isGreaterThanSmall,
  isMaterialVisible,
  isMenuVisible,
  isSidebarLeftVisible,
  isSidebarRightVisible,
  integrateMenu
}) {
  const toolbarStyle = getToolbarStyle();

  const showTitle = useMediaQuery("(min-width: 1055px)");

  if (isGreaterThanMedium) {
    if (sidebarLeftOpen && isSidebarLeftVisible) {
      toolbarStyle.paddingLeft = "300px";
    }

    if (sidebarRightOpen && isMaterialVisible && isSidebarRightVisible) {
      toolbarStyle.paddingRight = "300px";
    }
  }

  return (
    !integrateMenu &&
    isMenuVisible && (
      <AnnotationsMenuBar className="menu" style={toolbarStyle}>
        <AnnotationsMenuContent>
          <TitleWrapper visible={showTitle}>
            <BookTitle />
          </TitleWrapper>
          <PlayerWrapper>
            <PlayerBox
              hasPaddingLeft={isGreaterThanMedium && sidebarLeftOpen && isSidebarLeftVisible}
              hasPaddingRight={isGreaterThanMedium && sidebarRightOpen && isSidebarRightVisible}
            >
              <PlayerButtons />
            </PlayerBox>
          </PlayerWrapper>
          <div>
            <AnnotationeerControls />
            <PageControls />
          </div>
        </AnnotationsMenuContent>
      </AnnotationsMenuBar>
    )
  );
}

AnnotationsMenu.whyDidYouRender = false;

AnnotationsMenu.propTypes = {
  sidebarLeftOpen: PropTypes.bool.isRequired,
  sidebarRightOpen: PropTypes.bool.isRequired,
  isGreaterThanMedium: PropTypes.bool.isRequired,
  isGreaterThanSmall: PropTypes.bool.isRequired,
  isMaterialVisible: PropTypes.bool.isRequired,
  isMenuVisible: PropTypes.bool.isRequired,
  isSidebarLeftVisible: PropTypes.bool.isRequired,
  isSidebarRightVisible: PropTypes.bool.isRequired,
  integrateMenu: PropTypes.bool.isRequired
};

export default AnnotationsMenu;
